import { render, staticRenderFns } from "./interactiveanswer.vue?vue&type=template&id=0a5cce56&scoped=true&"
import script from "./interactiveanswer.vue?vue&type=script&lang=js&"
export * from "./interactiveanswer.vue?vue&type=script&lang=js&"
import style0 from "./interactiveanswer.vue?vue&type=style&index=0&id=0a5cce56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5cce56",
  null
  
)

export default component.exports